import NudosGenericModal from './NudosGenericModal';

export default NudosGenericModal;
